import { useContext } from 'react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'

const useRightsholderReset = () => {
    const { rightsholderStore, rightsholderUserStore, catalogSearchStore, catalogSearchBulkActionStore } =
        useContext<RootStore>(StoresContext)

    return () => {
        catalogSearchStore.resetStore()
        rightsholderUserStore.destroyRightsHolderUserToAbility()
        rightsholderStore.destroyRightsholder()
        catalogSearchBulkActionStore.resetStore()
    }
}

export default useRightsholderReset
